import type { SupabaseClient } from "@supabase/supabase-js";
import { createClient } from "@supabase/supabase-js";
import { CLAVE_SESION_INTERNA } from "@/reclutamiento/sesiones";

let supabaseClient: SupabaseClient | null = null;

export const getSupabaseClient = () => {
  if (!supabaseClient) {
    supabaseClient = createClient(
      import.meta.env.VITE_SUPABASE_URL,
      import.meta.env.VITE_SB_PUBLISHABLE_KEY,
      // Sesión propia de la interna: no se mezcla con la del portal (mismo origen). Ver sesiones.ts.
      { auth: { storageKey: CLAVE_SESION_INTERNA } },
    );
  }
  return supabaseClient;
};
